import { ActionType, createReducer } from 'typesafe-actions';

import * as walletActions from './actions';
import { StateWallets, walletsInitialState } from './wallet.initialState';
import {
  mapAccountsFromServer,
  mapCurrencies,
  mapFiltersForWalletTransactions,
  mapWalletsUpdateFromSocket,
  mapWalletTransactionsFilters,
  saveWalletTransactionsFiltersInSessionStorage,
} from './wallet.mapper';

type State = typeof walletsInitialState;
type Actions = ActionType<typeof walletActions>;

export const walletReducer = createReducer<State, Actions>(walletsInitialState)
  .handleAction(walletActions.actionLoadingGetWallets, (state) => ({
    ...state,
  }))
  .handleAction(walletActions.actionGetWallets, (state, action) => {
    const { accounts, wallets } = mapAccountsFromServer(action.payload);

    return {
      ...state,
      accounts: {
        ...state.accounts,
        main: accounts.main,
        derivatives: accounts.derivatives,
        earn: accounts.earn,
        stocks: accounts.stocks,
        loading: false,
        loadingInitial: false,
      },
      wallets,
      loading: false,
      initialLoading: false,
    };
  })
  .handleAction(walletActions.actionErrorGetWallets, (state, action) => ({
    ...state,
    loading: false,
    initialLoading: false,
    error: action.payload,
  }))
  .handleAction(walletActions.actionLoadingGetCurrencies, (state) => ({
    ...state,
    currenciesLoading: state.currenciesInitialLoading,
  }))
  .handleAction(walletActions.actionErrorGetCurrencies, (state, action) => ({
    ...state,
    currenciesLoading: false,
    error: action.payload,
  }))
  .handleAction(walletActions.actionSuccessGetCurrencies, (state, action) => ({
    ...state,
    currencies: mapCurrencies(state.currencies, action.payload),
    currenciesLoading: false,
    currenciesInitialLoading: false,
  }))
  .handleAction(walletActions.actionSuccessGetWalletConfiguration, (state, action) => ({
    ...state,
    configuration: action.payload,
  }))
  .handleAction(walletActions.actionUpdateWalletBalanceSuccess, (state, action) => {
    const updatedWallets: StateWallets = mapWalletsUpdateFromSocket(state.wallets, action.payload);

    return {
      ...state,
      wallets: updatedWallets,
    };
  })
  .handleAction(walletActions.actionSuccessGetBalance, (state, action) => ({
    ...state,
    loading: false,
    balance: {
      ...state.balance,
      ...action.payload,
      dailyChange: {
        ...state.balance.dailyChange,
        ...action.payload.dailyChange,
      },
    },
  }))
  .handleAction(walletActions.actionLoadingGetTransactions, (state) => ({
    ...state,
    transactions: {
      ...state.transactions,
      list: walletsInitialState.transactions.list,
      loading: true,
    },
  }))
  .handleAction(walletActions.actionGetTransactions, (state, action) => ({
    ...state,
    transactions: {
      ...state.transactions,
      list: mapFiltersForWalletTransactions(action.payload, state.transactions.filters),
      loading: false,
    },
  }))
  .handleAction(walletActions.actionErrorGetTransactions, (state) => ({
    ...state,
    transactions: {
      ...state.transactions,
      list: [],
      loading: false,
    },
  }))
  .handleAction(walletActions.actionUpdateTransactionsFilters, (state, action) => {
    const filters = mapWalletTransactionsFilters({
      ...state.transactions.filters,
      ...action.payload,
    });
    saveWalletTransactionsFiltersInSessionStorage(filters);
    return {
      ...state,
      transactions: {
        ...state.transactions,
        filters,
        list: walletsInitialState.transactions.list,
        loading: true,
      },
    };
  })
  .handleAction(walletActions.actionGetPaymentCardSuccess, (state, action) => ({
    ...state,
    paymentCard: action.payload,
    paymentCardLoading: false,
  }))
  .handleAction(walletActions.actionGetPaymentCardError, (state) => ({
    ...state,
    paymentCardLoading: false,
  }));
